import { Row, Col } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { Button } from 'App/components'
import { createProcessingSelector, removeEducationRequest, REMOVE_EDUCATION } from 'store'

export type TEducationRemoveDialogProps = {
  id: string
}

const processingRequest = createProcessingSelector([REMOVE_EDUCATION])

export const EducationRemoveDialog = ({ id }: TEducationRemoveDialogProps) => {
  const dispatch = useDispatch()

  const processing = useSelector(processingRequest)

  const { t } = useTranslation()

  const handleClick = () => {
    dispatch(removeEducationRequest({ id }))
  }

  return (
    <Row gutter={[0, 28]}>
      <Col xs={24}>
        <Row justify="center">
          <span>{t('modal.removeEducationConfirm.content')}</span>
        </Row>
      </Col>
      <Col xs={24}>
        <Row justify="center">
          <Button loading={processing} onClick={handleClick}>
            {t('modal.removeEducationConfirm.submitButton')}
          </Button>
        </Row>
      </Col>
    </Row>
  )
}
